//
// Graph.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./core/Layout";
import "./core/GraphMetadata";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./annotation/AnnotationDrawSpace";
import "./entry/EntryTitle";
import "./entry/EntryFootnote";
import "./legend/LayoutGlobalLegend";
import "@sas-dvr/ltjs-commons/styles/AttributePriority";
import "./SA/SimulatedAnnealingPlacementOptions";
import "./layoutOverlay/DataLabelPlacement";
import "./core/SymbolImage";
import "./core/SymbolChar";
import "./legend/LegendItem";
import "./legend/LegendTextItems";
import "./core/DataAnimation";
import "./core/SelectionMode";
import "./core/MissingValueDisplay";
import "./state/GTLGraphState";
import "@sas-dvr/ltjs-commons/rules/interfaces/Rule";
import "./data/GTLSortState";
import "@sas-dvr/ltjs-commons/resources/localization/LocalizationContext";
import "./core/styles/DataStyleCoordinator";
import "@sas-dvr/ltjs-commons/resources/images/ImageSet";
import "./axis/AxisLineExtentType";
import "./core/styles/GraphSkinModel";
import "./core/RendererModel";
import "./axis/AxisBreakSymbol";
import "./axis/AxisBreakType";
import "./overplotting/OverplottingPolicy";
import "./overplotting/OverplottingOptions";
import "./DisplayOptionPolicy";
import "./axis/DiscreteAxisOffsetReference";

var Graph = createModule("gtl::Graph", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::Layout"], EventDispatcher, [
    ,
    {
        discreteAxisOffsetReference: 4,
        labelingLimit: 4,
        axisTickMax: 4,
        simulatedAnnealingLabelPlacementOptions: 1,
        overplottingOptions: 1,
        designWidth: 1,
        discreteMax: 4,
        legendItems: [1],
        missingValueDisplay: 4,
        emphasizedModels: [1],
        gapScalingFactor: 5,
        dataSymbols: [7],
        casData: 2,
        suppressClientMsg: 2,
        nXYBinsMax: 4,
        totalCellMax: 4,
        nBinsMax: 4,
        showTimeTips: 2,
        showDefaultTooltips: 2,
        dataSkinMax: 4,
        localizationContext: 1,
        imagemapLimit: 4,
        dataStyleCoordinator: 1,
        axisLineExtent: 6,
        sparkThreshold: 1,
        animation: 1,
        axisBreakType: 4,
        sortState: 1,
        meta: 1,
        drawSpace: 4,
        showReferenceLine: 2,
        dataLinePatterns: [7],
        dataColors: [7],
        renderAsStaticOutput: 2,
        layoutGlobalLegend: 1,
        legendTextItems: [1],
        selectionMode: 4,
        renderer: 7,
        initialGraphState: 1,
        imageSet: 1,
        showBrush: 2,
        scaleMarkers: 2,
        groupMax: 4,
        dataFillPatterns: [7],
        axisBreakSymbol: 4,
        displayOptionPolicy: 4,
        symbolImages: [1],
        panelCellMax: 4,
        drillTarget: 7,
        designHeight: 1,
        maxLegendArea: 5,
        graphSkin: 1,
        overplottingPolicy: 1,
        titles: [1],
        symbolChars: [1],
        dataSizeScalingFactor: 5,
        labelPlacement: 4,
        layout: 1,
        includeMissingDiscrete: 2,
        displayRule: 1,
        attributePriority: 4,
        axisLineExtentType: 4,
        dataContrastColors: [7],
        footnotes: [1],
        showAnimationControls: 2,
    },
    ,
    ,
    {
        isOverviewSupported: [2],
        isZoomOverlaySupported: [2],
        setStyle: [0,1],
        onSizeScalingFactorsChanged: [0,1],
        _onStyleChange: [0,1],
        getLinearScalingFactor: [5],
    },
    {
        _create: [4],
    },
    ,
]);
export default Graph;
